const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssertionLogoicon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 516.986",
    style: {
      enableBackground: "new 0 0 1080 516.986"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: -4.045,
    y: -1.936,
    style: {
      fill: "#161A21"
    },
    width: 1088.089,
    height: 520.858
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M166.577,205.571h-27.83L98.612,311.414h27.06l6.909-19.6l19.407-54.339l11.727,32.235h-0.055 l8.01,22.105l7.075,19.6h28.133L166.577,205.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.041,250.111l-35.483-8.533c-3.028-0.771-4.68-3.303-4.68-5.671 c0-2.698,1.817-5.065,5.726-5.065h51.119v-25.27h-52.77c-20.315,0-30.693,15.168-30.693,30.803 c0,12.8,7.515,25.601,23.481,29.537l35.621,8.699c3.468,0.798,5.12,3.166,5.12,5.671c0,2.863-2.257,5.863-6.028,5.863h-54.119 v25.27h55.027c20.618,0,31.134-15.636,31.134-31.602C307.494,266.875,300.117,254.075,284.041,250.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M384.63,250.111l-35.483-8.533c-3-0.771-4.652-3.303-4.652-5.671c0-2.698,1.789-5.065,5.698-5.065 h51.119v-25.27h-52.77c-20.288,0-30.666,15.168-30.666,30.803c0,12.8,7.515,25.601,23.453,29.537l35.621,8.699 c3.469,0.798,5.12,3.166,5.12,5.671c0,2.863-2.257,5.863-6.001,5.863h-54.146v25.27h55.027c20.618,0,31.134-15.636,31.134-31.602 C408.083,266.875,400.733,254.075,384.63,250.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M496.945,230.842v-25.27h-78.481v105.843h78.481v-25.27h-53.679V269.71h46.164v-23.701h-46.164 v-15.168H496.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M585.064,258.176v-0.633c6.331-4.735,9.938-12.332,9.938-22.435 c0-19.434-14.59-29.537-35.648-29.537h-52.027v105.843h24.802V277.28h35.345c3.606,0,5.726,2.065,5.726,5.863v28.271h24.802 v-32.868C598.002,267.013,593.488,260.379,585.064,258.176z M557.261,254.24h-25.133v-23.398h25.27 c7.377,0,12.938,4.102,12.938,11.369C570.337,249.973,565.079,254.24,557.261,254.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M699.454,205.571h-91.061v25.27h32.62v80.573h24.83v-80.573h43.246L699.454,205.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M823.791,205.571c-31.355,0-51.09,24.188-51.09,53.225c0,28.72,19.735,52.619,51.09,52.619 c31.381,0,51.117-23.898,51.117-52.619C874.908,229.76,855.041,205.571,823.791,205.571z M823.791,286.91 c-17.127,0-26.902-13.438-26.902-28.43c0-15.256,9.934-28.404,26.902-28.404c16.995,0,26.928,13.148,26.928,28.404 C850.72,273.604,840.786,286.91,823.791,286.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M956.558,205.571v64.139l-43.741-64.139h-27.527v105.843h24.802v-67.607l46.466,67.607h24.83 V205.571H956.558z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 744.0701,
    y1: 207.3821,
    x2: 744.0701,
    y2: 310.873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9045"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6600"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "777.543,311.414 750.897,311.414 710.597,205.571 737.243,205.571  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssertionLogoicon01);
export default __webpack_public_path__ + "static/media/Assertion Logo & icon-01.355260dcf52d2ebdb4b2d3ecbe15a104.svg";
export { ForwardRef as ReactComponent };